import React from 'react';

// Components
import MenuItem from '@material-ui/core/MenuItem';

interface MenuItem {
  categoryOfCategories: boolean;
  isSubCategory: boolean;
  id: string;
  displayName: string;
}

export default function buildCategoryMenuItems(
  categoryChildren: any[],
  globalConfig: any,
  firstMenuItemDisplayName: string,
) {
  const menuItems = categoryChildren.map((item: any, index: number) => {
    const globalType = item.type === 'category' ? globalConfig.categories : globalConfig.fields;
    const { displayName, id } = globalType[item.name];

    return (
      <MenuItem value={index} key={id}>
        {displayName}
      </MenuItem>
    );
  });

  menuItems.unshift(
    <MenuItem value={-1} key={firstMenuItemDisplayName}>
      {firstMenuItemDisplayName}
    </MenuItem>,
  );

  return menuItems;
}
